export default "__VITE_ASSET__SXizUwOY__"